/*global $, document, window, setTimeout, alert, FG, confirm, location*/
(function () {
    "use strict";
    var CSRF_TOKEN = FG.Utils.getToken();
    FG.Cart = {
        init: function () {
            this.initRemoveFromCart();
            this.initDeleteCart();
            this.initChangeQuantity();
            this.initCostBreakout();
        },

        // * Make the dropdown icon clickable in the order summary module
        initCostBreakout: function () {

            $('#orderSummary a.open_ind').click(function () {
                $(this).parents('li').find('div.cost-breakout').slideDown('fast', function () {
                    $(this).show();
                });
                $(this).parents('li').find('a.close_ind').show();
                $(this).hide();
                return false;
            });

            $('#orderSummary a.close_ind').click(function () {
                $(this).parents('li').find('div.cost-breakout').slideUp('fast', function () {
                    $(this).hide();
                });
                $(this).parents('li').find('a.open_ind').show();
                $(this).hide();
                return false;
            });
        },

        /**
         * Change quantity dropdown on the shopping cart page.
         */
        initChangeQuantity: function () {

            $('#cart_fragment .sel-qty').on('change', function (e) {
                e.preventDefault();

                var quantity = parseInt($(this).val()),
                    sectionId = $(this).data('sectionid'),
                    ticketTypeId = $(this).data('tickettypeid'),
                    eventHubId = $(this).data('eventhubid'),
                    labelRoot = $(this).data('labelroot'),
                    $addToCart = $('#modal-addcart');


                $addToCart.modal({
                    backdrop: 'static',
                    keyboard: false
                }).show();


                var Ajax = new FG.Ajax('cart/update_quantity');

                Ajax.setMessageDiv('#div-add-cart-message');

                Ajax.setRequestData({
                    quantity: quantity,
                    sectionId: sectionId,
                    ticketTypeId: ticketTypeId,
                    eventHubId: eventHubId,
                    labelRoot : labelRoot,
                    csrf_token: CSRF_TOKEN
                });

                Ajax.setSuccessCallback(function(FGResponse){
                    $(".heading-tickets").html('Please wait');
                    $("#div-add-cart-message").html(FGResponse.msg);

                    var db = new FG.DB();
                    db.set('totalCount', FGResponse.data.totalCount);
                    FG.Cart.checkCartCount(FGResponse.data.totalCount, false, '');

                });

                Ajax.setFailureCallback(function(FGResponse){

                    $(".heading-tickets").html('An error has occurred');

                    $('.modal-body').after('<div class="modal-footer"><button id="btn-modal-dismiss" type="button" class="fbtn" onclick="window.location.reload()">Continue</button></div>');

                    $("#div-add-cart-message").html(FGResponse.msg);
                });

                Ajax.send();
            });
        },

        /**
         * Prime the remove xticket from cart link
         */
        initDeleteCart: function () {

            $("a.clearCart").click(function () {
                var labelRoot = $(this).data('labelroot'),
                    isCheckoutPage = $(this).data('checkout'),
                    isRenewalOrder = $(this).data('renewal'),
                    cartURL = labelRoot+'/cart',
                    $addToCart = $('#modal-addcart'),
                    $clearCart = $('#modal-clearcart');

                    $clearCart.modal()



                    $('.confirm-clear').click(function(){
                        $clearCart.modal('hide');

                        $addToCart.modal({
                            backdrop: 'static',
                            keyboard: false
                        }).show();

                        $.post(
                            labelRoot + '/cart/delete_cart',
                            {keepSession : true, csrf_token: CSRF_TOKEN},
                            function (json) {
                                if (json.error == 0) {
                                    localStorage.removeItem('cxid');
                                    var db = new FG.DB();
                                    db.set('totalCount', json.data.totalCount);

                                    $('.cart-event-table .cart-event').each(function(){

                                        dataLayer.push({
                                            event:'removeFromCart',
                                            ecommerce:{
                                                remove: {
                                                    products:[{
                                                        name: $(this).data('eventname'),
                                                        id: $(this).data('eventid'),
                                                        price: $(this).data('price'),
                                                        brand: 'FGT',
                                                        category: $(this).data('category'),
                                                        variant: $(this).data('variant'),
                                                        quantity: $(this).data('quantity')
                                                    }]
                                                }
                                            }
                                        })
                                    })


                                    FG.Cart.checkCartCount(json.data.totalCount, isCheckoutPage || isRenewalOrder, cartURL);
                                } else {
                                    $('#div-add-cart-message').html(json.msg);
                                }
                            },
                            "json"
                        );

                return false;
                })
            });
        },

        /**
         * Prime the remove xticket from cart link
         */
        initRemoveFromCart: function () {


            $("a.removeFromCart").click(function () {

                var xTicketId = $(this).data('xticketid'),
                    seatReserveId = $(this).data('seatreserveid'),
                    price = $(this).data('price'),
                    eventKey = $(this).data('eventkey'),
                    eventName = $(this).data('eventname'),
                    eventCategory = FG.Cart['labelCategory'],
                    labelName = $(this).data('label'),
                    labelRoot = $(this).data('labelroot'),
                    isRenewalOrder = $(this).data('renewal'),
                    cartURL = labelRoot+'/cart',
                    packageInstance = $(this).data('packageinstance'),
                    $addToCart = $('#modal-addcart'),
                    $removeItem = $('#modal-removeitem'),
                    removeLink = $(this)

                $removeItem.modal();

                $('.confirm-remove').off('click.confirmRemove').on('click.confirmRemove', function () {
                    $removeItem.modal('hide');

                    $addToCart.modal({
                        backdrop: 'static',
                        keyboard: false
                    }).show();


                    if (typeof packageInstance == "undefined") {
                        if (typeof seatReserveId == "undefined") {
                            var removeType = 'xticket';
                            var removeDataObject = { xTicketId: xTicketId, csrf_token: CSRF_TOKEN };
                        } else {
                            var removeType = 'seat';
                            var removeDataObject = { xTicketId: xTicketId, seatReserveId: seatReserveId, csrf_token: CSRF_TOKEN };
                        }

                        $.post(
                            labelRoot + '/cart/remove_' + removeType,
                            removeDataObject,
                            function (json) {
                                if (json.error == 0) {
                                    //GTM
                                    var ticket = removeLink.closest('.cartEvent').find('.cart-event')
                                    var eventId = ticket.data('eventid')
                                    var eventName = ticket.data('eventname')
                                    var quantity = ticket.data('quantity')
                                    var eventPrice = ticket.data('price')
                                    var category = ticket.data('category')
                                    var variant = ticket.data('variant')

                                    dataLayer.push({
                                        event:'removeFromCart',
                                        ecommerce:{
                                            remove: {
                                                products:[{
                                                    name: eventName,
                                                    id: eventId,
                                                    price: eventPrice,
                                                    brand: 'FGT',
                                                    category: category,
                                                    variant: variant,
                                                    quantity: quantity
                                                }]
                                            }
                                        }
                                    })


                                    var db = new FG.DB();
                                    db.set('totalCount', json.data.totalCount);

                                    //Enhanced Ecommerce remove from cart
                                    var loginTypeTemp = $.cookie("FG_LOGIN_TYPE");
                                    if(typeof(loginTypeTemp) == "undefined" || loginTypeTemp === null) {
                                        var loginType = "Guest";
                                    } else {
                                        if(loginTypeTemp == "ExistingAccount" || loginTypeTemp == "CreateAccount"){
                                            var loginType = "Account";
                                        } else {
                                            var loginType = "Facebook";
                                        }
                                    }
                                    FG.Cart.checkCartCount(json.data.totalCount, isRenewalOrder, cartURL);
                                } else {
                                    $('#div-add-cart-message').html(json.msg);
                                    setTimeout(function() {
                                        window.location.reload();
                                    }, 3000);
                                }
                            },
                            "json"
                        );
                    } else {
                        $.post(
                            labelRoot + '/cart/remove_package_instance',
                            {
                                packageInstance: packageInstance,
                                csrf_token: CSRF_TOKEN
                            },
                            function (json) {
                                if (json.error == 0) {

                                    //GTM
                                    var ticketArray = removeLink.closest('.cartEvent').find('.cart-event')

                                    ticketArray.each(function(){
                                        var eventId = $(this).data('eventid')
                                        var eventName = $(this).data('eventname')
                                        var quantity = $(this).data('quantity')
                                        var eventPrice = $(this).data('price')
                                        var category = $(this).data('category')
                                        var quantity = $(this).data('quantity')
                                        var variant = $(this).data('variant')

                                        dataLayer.push({
                                            event:'removeFromCart',
                                            ecommerce:{
                                                remove: {
                                                    products:[{
                                                        name: eventName,
                                                        id: eventId,
                                                        price: eventPrice,
                                                        brand: 'FGT',
                                                        category: category,
                                                        variant: variant,
                                                        quantity: quantity
                                                    }]
                                                }
                                            }
                                        })
                                    })



                                    var db = new FG.DB();
                                    db.set('totalCount', json.data.totalCount);

                                    //Enhanced Ecommerce remove from cart
                                    var loginTypeTemp = $.cookie("FG_LOGIN_TYPE");
                                    if(typeof(loginTypeTemp) == "undefined" || loginTypeTemp === null) {
                                        var loginType = "Guest";
                                    } else {
                                        if(loginTypeTemp == "ExistingAccount" || loginTypeTemp == "CreateAccount"){
                                            var loginType = "Account";
                                        } else {
                                            var loginType = "Facebook";
                                        }
                                    }
                                    FG.Cart.checkCartCount(json.data.totalCount, false,'')
                                } else {
                                    $('#div-add-cart-message').html(json.msg);
                                }
                            },
                            "json"
                        );
                    }

                })

                return false;
            });
        },

        /**
         * Make a call out to the server and refresh the order summary
         */
        refreshOrderSummary: function () {

            var self = this,
                Ajax = new FG.Ajax('checkout/order_summary');

            try {
                Ajax.setRequestType('get');
                //Ajax.setMessageDiv('#order_summary_fragment');
                Ajax.setSuccessCallback(function (FGResponse) {
                    $('#order_summary_fragment').html(FGResponse.data.summary);
                    self.initCostBreakout();
                });
                Ajax.send();

            } catch (AjaxException) {
                Ajax.error(AjaxException.msg);
            }
        },

        /**
         * Delete a user's cart
         */
        deleteCart : function(keepSession){

            var Ajax = new FG.Ajax('cart/delete_cart');

            try{

                Ajax.setMessageDiv('div-cart-empty-msg');

                Ajax.setSuccessCallback(function(){
                    FG.CartTimer.init();
                });

                keepSession = typeof keepSession === "undefined" ? false : keepSession;
                Ajax.setData({dev : 'null',keepSession : keepSession, csrf_token: CSRF_TOKEN});

                Ajax.send();

            }catch(AjaxException){

                Ajax.error(AjaxException.msg);
            }
        },
        /**
         * Check if cart totalCount is 0 and reload or redirect page accordingly
         */
        checkCartCount : function(count, isRenewal,cartURL){
            if (count === 0) {
                FG.CartTimer.deleteTimer();
                FG.CartTimer.init();
                window.location.href = window.labelRoot;
            } else {
                isRenewal ? window.location.replace(cartURL) : window.location.reload();
            }
        }
    };

}());
